class User {
  constructor(api) {
    this.api = api;
  }

  getAll(fields, onSuccess, onError) {
    let extras = "";
    if (fields.includes) {
      extras += fields.includes;
    }
    if (fields.userType) {
      extras += ",roles&filter[type]=" + fields.userType;
    }
    if (fields.search) {
      extras += "&filter[search]=" + fields.search;
    }
    if (fields.sort && fields.sort !== 'name') {
      extras += "&sort=" + fields.sort;
    }
    if (fields.sort && fields.sort === 'name') {
      extras += "&sort=first_name,last_name";
    }
    if (fields.sort && fields.sort === '-name') {
      extras += "&sort=-first_name,-last_name";
    }
    if (fields.pageNumber) {
      extras += "&page[number]=" + fields.pageNumber;
    }
    if (!fields.paginate) {
      fields.paginate = false;
    }
    return this.api.http_fibercloud
      .get("v1/users?paginate="+ fields.paginate +"&include=company" + extras, {
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByID(id, fields, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/users/" + id + "?include=" + fields)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  create(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/users", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  edit(id, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/users/" + id, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  delete(id, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/users/" + id)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  changePassword(uuid, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/users/" + uuid + "/password", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getUserPreference(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("preferences", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  changeUserPreference(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .patch("preferences", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAssociatedCompanies(queryParams, onSuccess, onError) {
    let id = queryParams.id;
    delete queryParams.id;
    let params = "";
    for (const [query, value] of Object.entries(queryParams)) {
      params += params === "" ? "?" : "&";
      params += query + "=" + value;
    }
    return this.api.http_fibercloud
      .get("v1/users/" + id + "/companies" + params)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAvailableUsers(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/usersAvaliable/")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getTotalUsers(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/totalUsers/")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  revokeToken(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/users/unlock", { uuid: uuid })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  downloadAllUsers(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/users/export/excel")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default User;



// WEBPACK FOOTER //
// ./src/api/user.js